import React, {useState, useEffect} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  Typography,
  Grid,
  Box,
  FormControl,
  RadioGroup,
  TextField,
  IconButton,
} from '@mui/material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import {CUSTOM_EVENT_NAMES, fireCustomEvent} from '../../../util/Analytics';
import {range} from 'lodash';
import {theme} from '../../../Theme';

import painting from '@bidmii/common/src/data/prePackagedProjects/painting.json';
import windowWashing from '@bidmii/common/src/data/prePackagedProjects/windowWashing.json';
import landscaping from '@bidmii/common/src/data/prePackagedProjects/landscaping.json';
import drivewaySealing from '@bidmii/common/src/data/prePackagedProjects/drivewaySealing.json';
import roofing from '@bidmii/common/src/data/prePackagedProjects/roofing.json';
import windowReplacement from '@bidmii/common/src/data/prePackagedProjects/windowReplacement.json';
import flooring from '@bidmii/common/src/data/prePackagedProjects/flooring.json';
import bathroomReno from '@bidmii/common/src/data/prePackagedProjects/bathroomReno.json';
import garageMakeover from '@bidmii/common/src/data/prePackagedProjects/garageMakeover.json';
import Trusscore from '@bidmii/common/src/data/prePackagedProjects/Trusscore.json';
import Designmii from '@bidmii/common/src/data/prePackagedProjects/Designmii.json';
import DesignmiiWaterRoom from '@bidmii/common/src/data/prePackagedProjects/DesignmiiWaterRoom.json';

import BidmiiRadio from '../../../common/StyledComponents/BidmiiRadio';
import BidmiiTextField from '../../../common/StyledComponents/BidmiiTextField';
import BidmiiSelect from '../../../common/StyledComponents/BidmiiSelect';
import BidmiiSlider from '../../../common/StyledComponents/BidmiiSlider';
import BidmiiSwitch from '../../../common/StyledComponents/BidmiiSwitch';

const useStyles = makeStyles(() => ({
  root: {
    padding: window.outerWidth > 600 ? '30px 60px 60px' : 30,
    overflowY: 'scroll',
    height: window.outerWidth > 600 ? '60vh' : 'calc(100vh - 90px)',
    maxHeight: '100vh',

    '& .MuiFormGroup-root': {
      color: theme.palette.primary.main,
      '& label': {
        marginBottom: '0rem !important',
      },
    },
    '& .MuiFormControlLabel-root': {
      marginRight: 0,
    },
    '& .ck-editor__editable': {
      minHeight: 90,
    },
    '& .rounded-textfield input': {
      paddingTop: 8,
      paddingBottom: 8,
    },
    '& .MuiInputBase-input': {
      paddingTop: 2,
      paddingBottom: 2,
    },
  },
  numberInputButton: {
    padding: 0,
    color: theme.palette.primary.main,

    '&:disabled': {
      color: 'rgba(0,0,0,0.25)',
    },
  },
}));

export default function useTemplateWizard(props: $TSFixMe) {
  const classes = useStyles();

  const [details, setDetails] = useState(props.project.details ?? []);
  const [template, setTemplate] = useState(
    localStorage.getItem('prePackagedProject')
      ? // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
        JSON.parse(localStorage.getItem('prePackagedProject'))
      : null,
  );

  useEffect(() => {
    switch (props.templateKey) {
      case 'painting':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_PAINTING,
        );
        setTemplate(painting);
        break;
      case 'windowWashing':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_WINDOW,
        );
        setTemplate(windowWashing);
        break;
      case 'landscaping':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_YARD,
        );
        setTemplate(landscaping);
        break;
      case 'drivewaySealing':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_DRIVEWAY,
        );
        setTemplate(drivewaySealing);
        break;
      case 'bathroomReno':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_BATHROOM,
        );
        setTemplate(bathroomReno);
        break;
      case 'flooring':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_FLOORING,
        );
        setTemplate(flooring);
        break;
      case 'roofing':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_ROOFING,
        );
        setTemplate(roofing);
        break;
      case 'window_replacement':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_WINDOW_REPLACEMENT,
        );
        setTemplate(windowReplacement);
        break;
      case 'garageMakeover':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_GARAGE_MAKEOVER,
        );
        setTemplate(garageMakeover);
        break;
      case 'trusscore':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_TRUSSCORE,
        );
        setTemplate(Trusscore);
        break;
      case 'designmiiPackage1':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_DESIGNMII,
        );
        setTemplate(Designmii);
        break;
      case 'designmiiPackage2':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_DESIGNMII,
        );
        setTemplate(Designmii);
        break;
      case 'designmiiPackage3':
        fireCustomEvent(
          CUSTOM_EVENT_NAMES.NEW_PROJECT_WIZARD_PRE_PACKAGED_DESIGNMII,
        );
        setTemplate(DesignmiiWaterRoom);
        break;
      default:
        break;
    }
  }, [props.templateKey]);

  useEffect(() => {
    if (template && !localStorage.getItem('rfp') && !props.edit) {
      const prePackagedDetails = template.questions.map(
        (question: $TSFixMe) => {
          return {
            prompt: question.label,
            value: question.default,
            type: question.type,
          };
        },
      );
      setDetails(prePackagedDetails);
    }
  }, [props.edit, template]);

  const renderInput = (question: $TSFixMe) => {
    switch (question.type) {
      case 'number':
        return numberInput(question.label, question.step, question.default);
      case 'text':
        return textInput(question.label, question.placeholder, question.lines);
      case 'choice':
        return multipleChoice(question.label, question.options, 'N/A');
      case 'switch':
        return switchInput(question.label, question.default);
      case 'slider':
        return sliderInput(
          question.label,
          question.min,
          question.max,
          question.unit,
          question.default,
        );
      case 'select':
        return selectInput(question.label, question.items);
      default:
        break;
    }
  };

  const textInput = (label: string, placeholder: string, lines: number) => {
    const answer = details.find((detail: $TSFixMe) => detail.prompt === label);
    const index = details.indexOf(answer);

    const handleTextInputChange = (event: $TSFixMe) => {
      const updatedDetails = [...details];
      updatedDetails[index] = {
        ...updatedDetails[index],
        value: event.target.value,
      };
      setDetails(updatedDetails);
      props.setDirty && props.setDirty(true);
    };

    return (
      <>
        <Typography
          variant="subtitle1"
          gutterBottom
          style={{fontSize: 15, marginRight: 16}}>
          {label}
        </Typography>
        <BidmiiTextField
          fullWidth
          value={answer?.value || ''}
          onChange={handleTextInputChange}
          placeholder={placeholder}
          multiline={Boolean(lines)}
          rows={lines || 1}
        />
      </>
    );
  };

  const numberInput = (
    label: $TSFixMe,
    step: $TSFixMe,
    defaultValue: $TSFixMe,
  ) => {
    const answer = details.find((detail: $TSFixMe) => detail.prompt === label);
    const index = details.indexOf(answer);

    const handleNumberInputChange = (num: $TSFixMe, manual: $TSFixMe) => {
      const updatedDetails = [...details];
      updatedDetails[index] = {
        ...updatedDetails[index],
        value: manual ? Number(num) : Number(answer.value) + num,
      };
      setDetails(updatedDetails);
      props.setDirty && props.setDirty(true);
    };

    return (
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography
            variant="subtitle1"
            style={{fontSize: 15, marginRight: 16}}>
            {label}
          </Typography>
        </Grid>
        <Grid item style={{display: 'flex', alignItems: 'center'}}>
          <IconButton
            // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
            onClick={() => handleNumberInputChange(-step || -1)}
            className={classes.numberInputButton}
            disabled={!answer || answer.value === 0}
            size="large">
            <RemoveIcon fontSize="small" />
          </IconButton>
          <Box mx={1}>
            <TextField
              variant="outlined"
              value={Number(answer?.value) || 0}
              onChange={(e) => handleNumberInputChange(e.target.value, true)}
              inputProps={{min: 0, style: {textAlign: 'center', width: 30}}}
            />
          </Box>
          <IconButton
            // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
            onClick={() => handleNumberInputChange(step || 1)}
            className={classes.numberInputButton}
            size="large">
            <AddIcon fontSize="small" />
          </IconButton>
        </Grid>
      </Grid>
    );
  };

  const multipleChoice = (
    label: $TSFixMe,
    options: $TSFixMe,
    defaultValue: $TSFixMe,
  ) => {
    const answer = details.find((detail: $TSFixMe) => detail.prompt === label);
    const index = details.indexOf(answer);

    const handleRadioChange = (event: $TSFixMe) => {
      const updatedDetails = [...details];
      updatedDetails[index] = {
        ...updatedDetails[index],
        value: event.target.value,
      };
      setDetails(updatedDetails);
      props.setDirty && props.setDirty(true);
    };

    return (
      <FormControl
        variant="standard"
        component="fieldset"
        style={{width: '100%'}}>
        <Typography variant="subtitle2" style={{fontSize: 15, marginRight: 16}}>
          {label}
        </Typography>
        <RadioGroup
          row
          name={label}
          value={answer?.value || defaultValue}
          onChange={handleRadioChange}>
          <Grid container alignItems="center">
            {options.map((option: $TSFixMe, i: $TSFixMe) => {
              return (
                <BidmiiRadio
                  key={i}
                  state={answer?.value || defaultValue}
                  value={option.value}
                  label={
                    option.image ? (
                      <Grid container direction="column" alignItems="center">
                        <img
                          alt={'Before'}
                          style={{width: 60, height: 60}}
                          src={option.label}
                        />
                        <Typography variant="caption">
                          {option.value}
                        </Typography>
                      </Grid>
                    ) : (
                      option.label
                    )
                  }
                  style={{
                    // width: `${100 / options.length}%`,
                    marginRight: 40,
                  }}
                />
              );
            })}
          </Grid>
        </RadioGroup>
      </FormControl>
    );
  };

  const switchInput = (label: $TSFixMe, defaultValue: $TSFixMe) => {
    const answer = details.find((detail: $TSFixMe) => detail.prompt === label);
    const index = details.indexOf(answer);

    const handleSwitch = (event: $TSFixMe) => {
      const updatedDetails = [...details];
      updatedDetails[index] = {
        ...updatedDetails[index],
        value: event.target.checked,
      };
      setDetails(updatedDetails);
      props.setDirty && props.setDirty(true);
    };
    const getChecked = () => {
      if (answer?.value) {
        return answer.value === 'true'
          ? true
          : answer.value === 'false'
            ? false
            : answer.value;
      } else {
        return defaultValue;
      }
    };
    return (
      <FormControl
        variant="standard"
        component="fieldset"
        style={{width: '100%'}}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Typography
            variant="subtitle1"
            style={{fontSize: 15, marginRight: 12}}>
            {label}
          </Typography>
          <BidmiiSwitch checked={getChecked()} onChange={handleSwitch} />
        </Grid>
      </FormControl>
    );
  };

  const sliderInput = (
    label: $TSFixMe,
    min: $TSFixMe,
    max: $TSFixMe,
    unit: $TSFixMe,
    defaultValue: $TSFixMe,
  ) => {
    const answer = details.find((detail: $TSFixMe) => detail.prompt === label);
    const index = details.indexOf(answer);

    const handleSliderChange = (event: $TSFixMe, newValue: $TSFixMe) => {
      const updatedDetails = [...details];
      updatedDetails[index] = {
        ...updatedDetails[index],
        value: newValue,
      };
      setDetails(updatedDetails);
      props.setDirty && props.setDirty(true);
    };

    return (
      <>
        <Grid container>
          <Typography
            variant="subtitle1"
            style={{fontSize: 15, marginRight: 16}}>
            {label}
          </Typography>
          <Typography variant="subtitle1" style={{fontSize: 15}}>
            {answer?.value || defaultValue} {unit}
          </Typography>
        </Grid>
        <BidmiiSlider
          onChange={handleSliderChange}
          defaultValue={answer?.value || defaultValue}
          step={1}
          min={min}
          max={max}
          marks={[
            {value: min, label: min},
            {value: max, label: max},
          ]}
        />
      </>
    );
  };

  const selectInput = (label: $TSFixMe, items: $TSFixMe) => {
    const currentYear = new Date().getFullYear();
    const years = ['N/A', ...range(currentYear, 1990, -1)];

    const answer = details.find((detail: $TSFixMe) => detail.prompt === label);
    const index = details.indexOf(answer);

    const handleSelectChange = (event: $TSFixMe) => {
      const updatedDetails = [...details];
      updatedDetails[index] = {
        ...updatedDetails[index],
        value: event.target.value,
      };
      setDetails(updatedDetails);
      props.setDirty && props.setDirty(true);
    };

    return (
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item>
          <Typography
            variant="subtitle1"
            style={{fontSize: 15, marginRight: 16}}>
            {label}
          </Typography>
        </Grid>
        <BidmiiSelect
          value={answer?.value || currentYear}
          onChange={handleSelectChange}
          style={{width: '100%', minWidth: 120}}
          MenuProps={{style: {maxHeight: 500}}}
          items={template.title === 'Driveway Sealing' ? years : items}
        />
      </Grid>
    );
  };

  const templateInputs = (
    <div>
      {template && (
        <Grid container direction="column">
          <Box mb={3}>
            {template.questions.map((question: $TSFixMe) => {
              const lessMargin = ['slider', 'switch', 'choice'].includes(
                question.type,
              );
              return (
                <Box key={question.id} mb={lessMargin ? 2 : 3}>
                  {renderInput(question)}
                </Box>
              );
            })}
          </Box>
        </Grid>
      )}
    </div>
  );

  return [templateInputs, details, template];
}
